import FormStruct from "@/components/Form/FormStruct/FormStruct";
import { FV } from "@/components/Form/Validation/FormValidators";
import i18n from "@/i18n";
import { AssetTypes } from "@/model/AssetTypes";
import { CustomFieldEditType } from "@/modules/customfields/CustomField.interface";
import CFAttachment, {
  NewAttachmentValue,
} from "@/modules/customfields/fields/CFAttachment";
import React from "react";
import { Field } from "react-final-form";

export type VacancyRentCoverageFormType = {
  rentOffer: NewAttachmentValue[];
};

type Props = {
  onSuccess: (rentOffer: NewAttachmentValue) => void;
  onCancel: () => void;
};

const VacancyRentCoverageForm = (props: Props) => {
  const { onSuccess, onCancel } = props;

  return (
    <div>
      <FormStruct
        submitText={i18n.t(
          "apTemplate:Vacancy.OfferActionFlow.RentCoverage.SubmitBtn",
          "Mietbescheinigung anfordern"
        )}
        cancelText={i18n.t("Global.Buttons.cancel", "Abbrechen")}
        onAbort={onCancel}
        render={() => {
          return (
            <div>
              <Field
                name="rentOffer"
                validate={FV.compose(FV.required(), FV.min(1))}
              >
                {(field) => (
                  <div className={`margin-bottom-20`}>
                    <CFAttachment
                      field={field}
                      accept={{
                        "application/pdf": [],
                      }}
                      assetType={AssetTypes.ActivityRelated.VacancyApplication}
                      data={{
                        displayName: i18n.t(
                          "apTemplate:Vacancy.OfferActionFlow.RentCoverage.Title",
                          "Mietangebot"
                        ),
                        fieldType: CustomFieldEditType.attachment,
                        id: "attachments",
                        validation: [
                          {
                            type: "required",
                          },
                          {
                            type: "min",
                            param: 1,
                          },
                          {
                            type: "max",
                            param: 1,
                          },
                        ],
                      }}
                    />
                  </div>
                )}
              </Field>
            </div>
          );
        }}
        onSubmit={(data: VacancyRentCoverageFormType) => {
          const attachments = data.rentOffer || [];
          if (attachments.length === 0) {
            throw new Error(
              i18n.t(
                "apTemplate:Vacancy.OfferActionFlow.RentCoverage.Error",
                "Bitte laden Sie eine Mietbescheinigung hoch."
              )
            );
          }

          const rentOffer = attachments[0];
          onSuccess(rentOffer);
        }}
      />
    </div>
  );
};

export default VacancyRentCoverageForm;
